<template>
    <div>
        <div class="pa-4 mt-3 border-solid border-gray-200 border-2">
            <v-data-table dense
                :headers="headers"
                :items="filtereddata()"
                item-key="id"
                no-data-text="No record"
                no-results-text="No record"
                :items-per-page="50"
                :footer-props="{
                    'items-per-page-options': [ 10, 20, 30, 40, 50 ]
                }"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-row dense no-gutters>
                            <v-col cols="4">
                                <v-menu ref="mnudatepicker" v-model="mnudatepicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="formatteddate" label="Report Date" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="seldate" no-title @input="mnudatepicker = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" dark class="mb-2 mr-2" @click="printreport()">Print</v-btn>
                        <download-excel class="bg-green-800 rounded-md mb-2 pa-2 text-white" :data="filtereddata()" :fields="fieldstoexport" :worksheet="'Daily Report ' + seldate" :name="'daily_report_' + seldate + '.xls'">
                            <v-icon left small color="white">mdi-microsoft-excel</v-icon>
                            <span class="v-btn text-sm">EXPORT</span>
                        </download-excel>
                    </v-toolbar>
                </template>
                <template v-slot:[`header.bpcompany`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtcompany ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtcompany" label="Business Partner" outlined dense></v-text-field>
                            <v-btn @click="filterfields.txtcompany = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.bpopname`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtoperator ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtoperator" label="Operator" outlined dense></v-text-field>
                            <v-btn @click="filterfields.txtoperator = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.region`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtregion ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtregion" label="Region" outlined dense></v-text-field>
                            <v-btn @click="filterfields.txtregion = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`item.no`]="{ item }">
                    <small>{{ dataitems.indexOf(item) + 1 }}</small>
                </template>
                <template v-slot:[`item.bpcompany`]="{ item }">
                    <small>{{ item.bpcompany + ' (' + item.bpqid + ')' }}</small>
                </template>
                <template v-slot:[`item.bpopname`]="{ item }">
                    <small>{{ item.bpopname + ' (' + item.bpopqid + ')' }}</small>
                </template>
                <template v-slot:[`item.orderno`]="{ item }">
                    <small>{{ item.orderno }}</small>
                </template>
                <template v-slot:[`item.svcno`]="{ item }">
                    <small>{{ item.svcno }}</small>
                </template>
                <template v-slot:[`item.svctype`]="{ item }">
                    <small>{{ item.svctype }}</small>
                </template>
                <template v-slot:[`item.cafsno`]="{ item }">
                    <small>{{ item.cafsno }}</small>
                </template>
                <template v-slot:[`item.ordertype`]="{ item }">
                    <small>{{ item.ordertype + ' - ' + item.ordertypedesc }}</small>
                </template>
                <template v-slot:[`item.orderstatus`]="{ item }">
                    <small>{{ item.orderstatus + ' - ' + item.orderstatusdesc }}</small>
                </template>
                <template v-slot:[`item.region`]="{ item }">
                    <small>{{ item.region + ' - ' + item.regiondesc }}</small>
                </template>
                <template v-slot:[`item.dateinstall`]="{ item }">
                    <small>{{ $moment(item.dateinstall).format('DD/MM/YYYY') }}</small>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                    <small>{{ $moment(item.created_at).format('DD/MM/YYYY h:mm A') }}</small>
                </template>
                <template v-slot:[`item.remarks`]="{ item }">
                    <small>{{ (item.remarks) ? shorten(item.remarks, 50) : '' }}</small>
                </template>
                <template v-slot:[`item.ordercost`]="{ item }">
                    <small>RM {{ parseFloat(item.ordertypecost).toFixed(2) }}</small>
                </template>
                <template v-slot:[`item.orderextracharges`]="{ item }">
                    <small>RM {{ (item.orderextracharges) ? parseFloat(item.orderextracharges).toFixed(2) : '0.00' }}</small>
                </template>
                <template v-slot:[`item.ordertotalcost`]="{ item }">
                    <small>RM {{ parseFloat(item.ordertotalcost).toFixed(2) }}</small>
                </template>
            </v-data-table>
        </div>
        <v-dialog v-model="dlgprint" fullscreen persistent>
            <v-card>
                <v-toolbar flat color="primary" dark>
                    Print Report
                    <v-spacer></v-spacer>
                    <v-btn text @click="printthis('printArea')">Print</v-btn>
                    <v-btn dark icon @click="dlgprint = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text id="printArea" class="p-3">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <h5>Daily Order Transactions Report: {{ formatteddate }}</h5>
                        </v-col>
                        <v-col cols="12">
                            <small><b>Print Date:</b> {{ $moment(new Date).format('DD/MM/YYYY h:mm A') }}</small>
                        </v-col>
                    </v-row>
                    <v-simple-table dense width="100%">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th><small><b>No.</b></small></th>
                                    <th><small><b>Business Partner</b></small></th>
                                    <th><small><b>Operator</b></small></th>
                                    <th><small><b>Order No.</b></small></th>
                                    <th><small><b>Service No.</b></small></th>
                                    <th><small><b>Service No. Type</b></small></th>
                                    <th><small><b>CAF Serial No.</b></small></th>
                                    <th><small><b>Order Type</b></small></th>
                                    <th><small><b>Order Status</b></small></th>
                                    <th><small><b>Region</b></small></th>
                                    <th><small><b>Date Install</b></small></th>
                                    <th><small><b>Date Submit</b></small></th>
                                    <th><small><b>Remarks</b></small></th>
                                    <th><small><b>Order Cost</b></small></th>
                                    <th><small><b>Extra Charges</b></small></th>
                                    <th><small><b>Total Cost</b></small></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in filtereddata()" :key="item.id">
                                    <td><small>{{ dataitems.indexOf(item) + 1 }}</small></td>
                                    <td><small>{{ item.bpcompany + ' (' + item.bpqid + ')' }}</small></td>
                                    <td><small>{{ item.bpopname + ' (' + item.bpopqid + ')' }}</small></td>
                                    <td><small>{{ item.orderno }}</small></td>
                                    <td><small>{{ item.svcno }}</small></td>
                                    <td><small>{{ item.svctype }}</small></td>
                                    <td><small>{{ item.cafsno }}</small></td>
                                    <td><small>{{ item.ordertype + ' - ' + item.ordertypedesc }}</small></td>
                                    <td><small>{{ item.orderstatus + ' - ' + item.orderstatusdesc }}</small></td>
                                    <td><small>{{ item.region + ' - ' + item.regiondesc }}</small></td>
                                    <td><small>{{ $moment(item.dateinstall).format('DD/MM/YYYY') }}</small></td>
                                    <td><small>{{ $moment(item.created_at).format('DD/MM/YYYY h:mm A') }}</small></td>
                                    <td><small>{{ (item.remarks) ? shorten(item.remarks, 50) : '' }}</small></td>
                                    <td><small>RM {{ parseFloat(item.ordertypecost).toFixed(2) }}</small></td>
                                    <td><small>RM {{ (item.orderextracharges) ? parseFloat(item.orderextracharges).toFixed(2) : '0.00' }}</small></td>
                                    <td><small>RM {{ parseFloat(item.ordertotalcost).toFixed(2) }}</small></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="sbmsg" timeout="5000" color="green darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sbmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="sberrmsg" timeout="5000" color="red darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sberrmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
const axios = require('axios')

export default {
    name: 'TableReportDailyAdmin',
    components: {},
    props: {},
    data() {
        return {
            dataitems: [],
            headers: [
                { text: "No.",                  value: "no",                sortable: false, align: "start", width: '40px' },
                { text: "Business Partner",     value: "bpcompany",         sortable: false },
                { text: "Operator",             value: "bpopname",          sortable: false },
                { text: "Order No.",            value: "orderno",           sortable: false },
                { text: "Service No.",          value: "svcno",             sortable: false },
                { text: "Service No. Type",     value: "svctype",           sortable: false },
                { text: "CAF Serial No.",       value: "cafsno",            sortable: false },
                { text: "Order Type",           value: "ordertype",         sortable: false },
                { text: "Order Status",         value: "orderstatus",       sortable: false },
                { text: "Region",               value: "region",            sortable: false },
                { text: "Date Install",         value: "dateinstall",       sortable: false },
                { text: "Date Submit",          value: "created_at",        sortable: false },
                { text: "Remarks",              value: "remarks",           sortable: false },
                { text: "Order Cost",           value: "ordercost",         sortable: false },
                { text: "Extra Charges",        value: "orderextracharges", sortable: false },
                { text: "Total Cost",           value: "ordertotalcost",    sortable: false },
            ],
            sbmsg: false,
            sberrmsg: false,
            msg: '',
            seldate: '',
            formatteddate: '',
            mnudatepicker: false,
            pickeddate: '',
            ddordertypes: [],
            ddorderstatus: [],
            ddbizpartners: [],
            fieldstoexport: {
                "Business Partner": "bpqid",
                "Operator": "bpopqid",
                "Order No.": {
                    field: "orderno",
                    callback: (value) => {
                        return "'" + String(value)
                    }
                },
                "Service No.": {
                    field: "svcno",
                    callback: (value) => {
                        return "'" + String(value)
                    }
                },
                "Service No. Type": "svctype",
                "CAF Serial No.": {
                    field: "cafsno",
                    callback: (value) => {
                        return "'" + String(value)
                    }
                },
                "Order Type": {
                    field: "ordertypedesc",
                    callback: (value) => {
                        return value
                    }
                },
                "Order Status": {
                    field: "orderstatusdesc",
                    callback: (value) => {
                        return value
                    }
                },
                "Region": {
                    field: "region",
                    callback: (value) => {
                        return String(value)
                    }
                },
                "Date Install": "dateinstall",
                "Date Submit": {
                    field: "created_at",
                    callback: (value) => {
                        return this.$moment(value).format('DD/MM/YYYY h:mm A')
                    }
                },
                "Remarks": "remarks",
                "Order Cost": {
                    field: "ordertypecost",
                    callback: (value) => {
                        return value
                    }
                },
                "Extra Charges": "orderextracharges",
                "Total Cost": "ordertotalcost"
            },
            dlgprint: false,
            filterfields: {
                txtcompany: '',
                txtoperator: '',
                txtregion: '',
            }
        }
    },
    watch: {
        seldate: function (newval, oldval) {
            if (newval) {
                this.formatteddate = this.$moment(newval).format('DD/MM/YYYY')
                this.getdata()
            }
        }
    },
    mounted: function () {
        this.initialize()
    },
    methods: {
        initialize() {
            this.$nextTick(() => {
                this.seldate = this.$moment(new Date).format('YYYY-MM-DD')
            })
        },

        getdata() {
            var targetPath = '/admin/report-daily/' + this.seldate
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.dataitems = rtn.data
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                        this.dataitems = []
                    }
                }
            })
        },

        filtereddata() {
            var conditions = []

            if (this.filterfields.txtcompany) { conditions.push(this.filtercompany) }
            if (this.filterfields.txtoperator) { conditions.push(this.filteroperator) }
            if (this.filterfields.txtregion) { conditions.push(this.filterregion) }

            if (conditions.length > 0) {
                return this.dataitems.filter((item) => {
                    return conditions.every((condition) => {
                        return condition(item)
                    })
                })
            }

            return this.dataitems
        },

        filtercompany(item) {
            return (item.bpcompany) ? item.bpcompany.toLowerCase().includes(this.filterfields.txtcompany.toLowerCase()) : null
        },

        filteroperator(item) {
            return (item.bpopname) ? item.bpopname.toLowerCase().includes(this.filterfields.txtoperator.toLowerCase()) : null
        },

        filterregion(item) {
            return (item.region) ? item.region.toLowerCase().includes(this.filterfields.txtregion.toLowerCase()) : null
        },

        printreport() {
            this.dlgprint = true
        },

        printthis(pPrintArea) {
            this.$htmlToPaper(pPrintArea)
        },

        shorten(str, maxLen, separator = ' ') {
            if (str.length <= maxLen) return str;
            return str.substr(0, str.lastIndexOf(separator, maxLen));
        }

    }
}
</script>

<style>

</style>
